import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  packageGetImage,
  packageAddImage
} from "actions/chargers/package/actions";
import Spinner from "../../../lib/components/Spinner";

class ImageModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      file: false
    };
  }

  handleChange = (ev) => {
    const files = Array.from(ev.target.files);
    this.setState({
      file: files[0]
    });
  };

  handleSubmit = () => {
    this.props.packageAddImage(this.props.packageId, this.state.file, () => {
    });
  };

  render() {
    const {
      loading,
      packageName,
      packageImage
    } = this.props;
    const { file } = this.state;

    return (
      <div className="position-relative">
        {!loading || <Spinner/>}
        <div className="my-2 text-center">
          {packageImage
            ? (
              <img
                className="img-thumbnail"
                alt={packageName}
                src={packageImage}
                style={{
                  maxHeight: 200,
                  width: "auto"
                }}
              />
            ) : null}
        </div>

        <div className="form-group">
          <label>Logo</label>
          <input
            className="form-control"
            type="file"
            accept="image/png"
            onChange={this.handleChange}
          />
        </div>

        <div className="text-right">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
            disabled={file === false}
          >
            Upload
          </button>
        </div>
      </div>
    );
  }
}

ImageModal.propTypes = {
  packageId: PropTypes.string.isRequired,
  packageName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: state.chargerPackage.loading,
  packageImage: state.chargerPackage.packageImage,
});

const mapStateToDispatch = dispatch => ({
  packageGetImage: bindActionCreators(packageGetImage, dispatch),
  packageAddImage: bindActionCreators(packageAddImage, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ImageModal);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/package/image-modal.js